import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PblNformMaterialModule } from '@pebula/nform-material';
import { SgAutoCompleteSelectModule } from '@sg/ui-kit/auto-complete-select/src';
import { SgCommonModule } from '../../common.module';
import { SgCommonFormTypesComponent } from './common-form-types/common-form-types.component';
import { SgReportQueryHostComponent } from './report-query-host/report-query-host.component';
import { SgSimpleModelEditorComponent } from './simple-model-editor/simple-model-editor.component';

const importsAndExports = [
  CommonModule,
  RouterModule,
  ReactiveFormsModule,
  PblNformMaterialModule,
  SgCommonModule,
  SgAutoCompleteSelectModule,
];

const declarationAndExports = [SgReportQueryHostComponent, SgCommonFormTypesComponent, SgSimpleModelEditorComponent];

@NgModule({
  imports: [importsAndExports],
  declarations: [declarationAndExports],
  exports: [declarationAndExports, importsAndExports],
})
export class SgCommonFormsModule {
  static forRoot(): ModuleWithProviders<SgCommonFormsModule> {
    return {
      ngModule: SgCommonFormsModule,
      providers: [...PblNformMaterialModule.forRoot().providers],
    };
  }
}
